import React, { useContext, useEffect } from 'react'
import { Heading } from 'monday-ui-react-core'
import { Buildings } from 'react-bootstrap-icons'
import { Row } from 'react-bootstrap'
import { StatementContext } from 'utils/context/StatementsContext'
import { StatementCard } from 'components/StatementCard'
import { LoadingSpinner } from 'components/LoadingSpinner'

const ReceiverDashboard = () => {
    const {
        isFetchingReceiverSummary,
        receiverStatements,
        getReceiverStatementsSummary
    } = useContext(StatementContext)

    const renderReceiverStatementCard = (receiverStatementData) => {
        // let urlWhenClicked = receiverStatementData.documentDescription.replace("Statements", "").trim().toLowerCase().replace(" ","-")
        return (
            <StatementCard
                key={receiverStatementData.documentType}
                statementInfo={{
                    documentType: receiverStatementData.documentType,
                    documentDescription: receiverStatementData.documentDescription,
                    amountAllStatements: receiverStatementData.amountAllStatements ?? 0,
                    amountStatementsCurrentMonth: receiverStatementData.amountStatementsCurrentMonth ?? 0,
                    //urlWhenClicked
                }}
                cardType="receiver"
            />
        )
    }

useEffect(() => {
        getReceiverStatementsSummary()
    }, [])

    return (
        <div className="container-cards">
            <Heading className="mb-0" value="Received Statements" />
            <p className="tile-click-text">Click a tile to view the documents.</p>
            {isFetchingReceiverSummary ? (
                <LoadingSpinner />
            ) : (
                receiverStatements !== null ? (
                    receiverStatements.length ? 
                    receiverStatements.map((receiverStatementData, i) => (
                        <div key={i}>
                            <div className="d-flex justify-content-start align-items-center mt-1">
                                <Buildings
                                    className="title-icon border-rounded-circle"
                                    size={17}
                                />
                                <Heading
                                    type={Heading.types.h3}
                                    value={receiverStatementData.documentDescription}
                                    ellipsis={false}
                                    className="pt-1 mb-0 ms-2"
                                />
                            </div>
                            <Row>
                                {
                                    renderReceiverStatementCard(receiverStatementData)
                                }
                            </Row>
                        </div>
                    ))
                    : undefined
                ) : undefined
            )}
        </div>
    )
    
}

export default ReceiverDashboard